import _ from 'lodash';

/*
 * Query string helpers
 */

// Cache parsed query here so it doesn't need to be parsed again in different components
let _parsed_query = null;
let _parsed_query_search = null;

/**
 * Parse query string in current URL, returning values in an object.
 *
 * The result is cached and if the query string hasn't changed from the last time, the same object is returned.
 *
 * Idea from: https://stackoverflow.com/a/13419367/3533441
 *
 * @return {Object.<String, null|String|Array.<null|String>>}
 */
function parseQueryString(search=window.location.search) {

  if (_parsed_query != null && _parsed_query_search === search) {
    return _parsed_query;
  }

  _parsed_query = {};

  if (search === '') {
    return Object.freeze(_parsed_query);
  }
  else {
    const vars = (search.startsWith('?')? search.substr(1) : search).split('&');

    for (const v of vars) {
      if (v === '') {
        continue;
      }

      const [key, value] = v.split('=');

      const decoded_key = decodeURIComponent(key);
      let decoded_value = '';

      // If there is no value (such as: ?foo&bar&baz), use null as value
      try {
        decoded_value = value != null? decodeURIComponent(value) : null;
      } catch (e) {
        // Don't break on ISO Latin encodings like %E4 for "ä"
        decoded_value = unescape(value);
      }

      // If the element already exists in the query, i.e. it is multiple times in the query string, turn the value
      // into an array if needed and push the new value to the end of it
      if (decoded_key in _parsed_query) {
        if (!_.isArray(_parsed_query[decoded_key])) {
          _parsed_query[decoded_key] = [_parsed_query[decoded_key]];
        }

        _parsed_query[decoded_key].push(decoded_value);
      }
      else {
        _parsed_query[decoded_key] = decoded_value;
      }
    }

    return Object.freeze(_parsed_query);
  }
}

export {
  parseQueryString
};




// WEBPACK FOOTER //
// ./src/app/common/query.utils.js